"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DocumentCardPreview.types.js.map